import { CloudController, CloudControllerReader, ReaderFirmwareUpdateStatus } from 'graphql/generated/graphqlTypes';

const makeReader = (
  cloudControllerId: string,
  serialNumber: string,
  firmwareUpdate?: { status: ReaderFirmwareUpdateStatus; percentage: number }
): CloudControllerReader => ({
  __typename: 'CloudControllerReader',
  serialNumber,
  cloudControllerId,
  doorId: null,
  firmwareUpdate: firmwareUpdate
    ? { __typename: 'ReaderFirmwareUpdate', tenantId: 'mock-tenant', doorId: 'mock-door', ...firmwareUpdate }
    : null
});

export const mockCloudControllers: CloudController[] = [
  {
    __typename: 'CloudController',
    id: '401871781566859',
    serialNumber: '401871781566859',
    readers: [
      makeReader('401871781566859', '26990008', { status: ReaderFirmwareUpdateStatus.Installing, percentage: 45 }),
      makeReader('401871781566859', '26990009', { status: ReaderFirmwareUpdateStatus.Succeeded, percentage: 100 }),
      makeReader('401871781566859', '26990010', { status: ReaderFirmwareUpdateStatus.Failed, percentage: 30 }),
      makeReader('401871781566859', '26990011')
    ]
  },
  {
    __typename: 'CloudController',
    id: '740475562400854',
    serialNumber: '740475562400854',
    readers: [makeReader('740475562400854', '26990012', { status: ReaderFirmwareUpdateStatus.Queued, percentage: 0 })]
  },
  { __typename: 'CloudController', id: '950966707523481', serialNumber: '950966707523481', readers: [] }
];
